export default "__VITE_ASSET__EivLb6So__"